import { includes } from 'lodash/fp';

import { Customer } from '../../../../selectors/select-customer/types';
import { SCALES_WITH_PARTNER } from '../../../../models/customer/constants';

const getHasPartner = (scale: Customer['scale'] | string) => includes(scale, SCALES_WITH_PARTNER);

export default getHasPartner;
